<template>
  <div class="hidden md:grid grid-cols-2 pb-10">
    <div class="flex items-center justify-center pl-32">
      <div class="flex flex-col">
        <h1 class="text-left py-10 text-black text-4xl font-extrabold">
          Who we are
        </h1>
        <p>
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Nemo dolorem
          perspiciatis minima, numquam dolores enim soluta. In voluptatibus,
          accusantium eaque aspernatur quasi harum maiores, culpa aut enim et
          nulla tempore! Veniam iusto adipisci quo ab repellendus. In sed veniam
          illum, doloribus accusantium amet minima, veritatis animi consequuntur
          error dolorem quis alias molestiae molestias accusamus eaque deserunt!
          Dolorum illum natus inventore! Molestias animi architecto veniam,
        </p>
      </div>
    </div>
    <div class="flex items-center justify-end pt-10 px-16">
      <div class="relative">
        <img
          class="h-96 w-auto"
          :src="require('@/assets/images/doctor.png')"
          alt="Logo"
        />
        <div
          class="absolute top-0 right-0 w-52 bg-white/50 backdrop-blur-md text-gray-700 px-4 py-3 rounded-2xl border border-white/40 shadow-[0_0_20px_rgba(0,0,0,0.1)] animate-bounce-slow"
        >
          <div class="flex flex-col">
            <div class="flex h-full gap-2.5">
              <img
                class="w-7 h-6"
                :src="require('@/assets/images/iwc.png')"
                alt="Logo"
              />
              <div class="flex flex-col">
                <span class="text-sm">IMS Wellth Care, Inc</span>
                <div class="flex">
                  <SVGStar v-for="n in 4" :key="n" class="w-4 h-4" />
                </div>
              </div>
            </div>
            <p class="text-xs">
              Partnering with IMF lets us deliver fast, reliable care anytime,
              anywhere. It’s healthcare beyond the clinic.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SVGFacebook from "@/components/svgs/facebook.vue";
import SVGStar from "@/components/svgs/star.vue";
export default {
  components: {
    SVGFacebook,
    SVGStar,
  },
  setup() {},
};
</script>
